const showSticky = (messages,severidade,titulo,detalhe,sticky) => {
    messages.current.show({severity: severidade, summary: titulo, detail: detalhe, sticky: sticky});
};
const clearMessage =  async (messages) => {
    messages.clear()
};
export {
    showSticky,
    clearMessage
}